import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import config from 'config'

import { SEARCH_ENTITIES } from 'constants/enums'

class SearchResult extends Component {
  static propTypes = {
    id: PropTypes.number,
    type: PropTypes.number,
    param: PropTypes.string,
    value: PropTypes.string,
    email: PropTypes.string
  }

  shouldComponentUpdate(nextProps) {
    return this.props.id !== nextProps.id
  }

  getUrl = () => {
    const { id, type, param } = this.props

    switch (type) {
      case SEARCH_ENTITIES.PARTICIPANT.id:
        return `${config.publicPath}/participants/${id}/detail`
      case SEARCH_ENTITIES.AL_REGISTRATION.id:
        return `${config.publicPath}/registrations/award-leaders`
      case SEARCH_ENTITIES.AU_REGISTRATION.id:
        return `${config.publicPath}/registrations/award-units`
      case SEARCH_ENTITIES.ASSESSOR_REGISTRATION.id:
        return `${config.publicPath}/tasks/assessors`
      case SEARCH_ENTITIES.ORG_CONTACT.id:
        return `${config.publicPath}/organizations/${param}/contacts/${id}`
      case SEARCH_ENTITIES.ORGANIZATION.id:
        return `${config.publicPath}/award-units/${id}/detail`
      default:
        return
    }
  }

  render() {
    const { id, value, email } = this.props

    return (
      <tr>
        <td>{id}</td>
        <td>{value}</td>
        <td>{email}</td>
        <td className="text--right" width="150">
          <Link to={this.getUrl()}>
            <span className="link">
              <FormattedMessage
                id="label.view_more"
                defaultMessage="View More"
              />
            </span>
          </Link>
        </td>
      </tr>
    )
  }
}

export default SearchResult
